"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentsSeriesSummariesPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var util_1 = require("../util");
var i18n_1 = __importDefault(require("../i18n"));
var TitleHelmet_1 = require("./TitleHelmet");
var SubPlaceButtons_1 = require("./SubPlaceButtons");
var useFirstGetContents_1 = require("../effects/useFirstGetContents");
var ContentsSeriesSummaries_1 = require("./ContentsSeriesSummaries");
exports.ContentsSeriesSummariesPage = (0, react_router_1.withRouter)(function (state) {
    (0, useFirstGetContents_1.useFirstGetContents)(state);
    var pageProps = (0, util_1.routePageProps)(state, { pageSize: state.usersPageSize, setPageSize: state.setUsersPageSize });
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: state.groupsLoading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: state.groupsLoading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsx)(TitleHelmet_1.TitleHelmet, { title: i18n_1.default.contents }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 1, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Column, { children: [(0, jsx_runtime_1.jsx)(SubPlaceButtons_1.SubPlaceButtons, {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/contents_series/new", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { as: "span", children: i18n_1.default.createContents }) })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: state.contentsSeriesList.length ? ((0, jsx_runtime_1.jsx)(ContentsSeriesSummaries_1.ContentsSeriesSummaries, __assign({ contentsSeriesList: state.contentsSeriesList, contentsItems: state.contentsItems }, pageProps))) : ((0, jsx_runtime_1.jsx)("p", { children: i18n_1.default.noContents })) })] })] }));
});
